import { connect } from 'react-redux';
import moment from 'moment';

import { setUXProp } from '@store/actions/ux';
import { requestFetchTvguide } from '@tvguide/store/actions/requests';
import Timeline from './timeline';

const mapStateToProps = state => ({
  minutesPixelRatio: state.ux.minutesPixelRatio,
  pixelRatioChanged: state.ux.pixelRatioChanged,
  beginDate: moment(state.ux.beginDate),
  endDate: moment(state.ux.endDate),
  activeDay: state.ux.activeDay,
  displayedTime: state.ux.displayedTime,
  nid: state.ux.nid,
  isLoaded: state.ux.load.programs,
  gridWidth:
    (moment(state.ux.endDate).diff(state.ux.beginDate, 'days') + 1) *
    24 *
    60 *
    state.ux.minutesPixelRatio,
});

const mapDispatchToProps = dispatch => ({
  setActiveDay: day => {
    dispatch(
      setUXProp({
        activeDay: day,
      }),
    );
  },
  setDisplayedTime: (start, end) => {
    dispatch(
      setUXProp({
        displayedTime: {
          start: start,
          end: end,
        },
      }),
    );
  },
  requestTvguide: (nid, start) => {
    dispatch(requestFetchTvguide(nid, start));
  },
  hasRendered: () => {
    dispatch(
      setUXProp({
        pixelRatioChanged: false,
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Timeline);
